module.exports = __webpack_public_path__ + "static/media/078.86e8609b.jpg";